const KEY_VOLUME = '@ligchat/msgNotifyVolume';
const KEY_PRESET = '@ligchat/msgNotifyPreset';

export type MessageNotifyPresetId = 'default' | 'beep';

export const MESSAGE_NOTIFY_PRESETS: { id: MessageNotifyPresetId; label: string }[] = [
  { id: 'default', label: 'Padrão' },
  { id: 'beep', label: 'Bipe curto' },
];

export function getMessageNotifyVolume(): number {
  const v = localStorage.getItem(KEY_VOLUME);
  if (v === null) return 1;
  const n = parseFloat(v);
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 1;
}

export function setMessageNotifyVolume(vol: number): void {
  localStorage.setItem(KEY_VOLUME, String(Math.min(1, Math.max(0, vol))));
}

export function getMessageNotifyPreset(): MessageNotifyPresetId {
  const v = localStorage.getItem(KEY_PRESET);
  if (v === 'beep') return 'beep';
  return 'default';
}

export function setMessageNotifyPreset(id: MessageNotifyPresetId): void {
  localStorage.setItem(KEY_PRESET, id);
}
